import { SxProps, Theme } from '@mui/material/styles'

type SxEntry = Extract<SxProps<Theme>, readonly unknown[]>[number]

export const toSxArray = (sx?: SxProps<Theme>): SxEntry[] => (Array.isArray(sx) ? [...sx] : sx ? [sx] : [])
